



















































































import { SliderVue } from "fs-pb-vue2/vueModels/app/SliderVue";
import { Component, Prop, Watch } from "vue-property-decorator";
import PreApprovedSolutionModal from "@/components/app/PreApprovedSolutionModal.vue"

@Component({
  components: { PreApprovedSolutionModal }
})
export default class Slider extends SliderVue {

  @Prop() preApprovedSolutionData: any[];

  // Локальные слайды для отображения
  localSlides: any[] = [];
  // Слайды, добавленные из preApprovedSolutionData
  newSlides: any[] = [];
  // Очередь новых слайдов для обработки
  slidesQueue: any[] = [];

  isModalOpen: boolean = false;
  modalData: any = null;

  openApprovedSolutionModal(slide: any) {
    if (slide.PreApprovedSolution) {
      this.modalData = slide; 
      this.isModalOpen = true;
    }
  }

  appropriateImage(item: any): string {
    const image = window.innerWidth >= 971 ? (item.ImageWeb ? item.ImageWeb : item.Image) : item.Image;
    return image;
  }

  // преобразование данные о предодобренном решении в структуру слайда
  private convertPropertiesToSlide(properties: any): any {
    return {
      Id: properties.Id,
      Caption: properties.Caption,
      Image: this.appropriateImage(properties),
      url: properties.ActionLink,
      text: properties.TextHtml,
      Images: properties.Images || [],
      PreApprovedSolution: true,
      ...properties
    };
  }

  // Обработчик изменений массива слайдов
  @Watch('slides', { immediate: true, deep: true })
  onSlidesChanged() {
    this.updateLocalSlides();
  }

  @Watch('preApprovedSolutionData', { immediate: true, deep: true })
  onPreApprovedSolutionDataChanged() {

    if (this.preApprovedSolutionData && this.preApprovedSolutionData.length) {
      this.newSlides = [];

      this.preApprovedSolutionData.forEach(dataItem => {
        const newSlide = this.convertPropertiesToSlide(dataItem);

        const isSlideExistsInQueue = this.slidesQueue.some(slide => slide.Id === newSlide.Id);
        const isSlideExistsInNewSlides = this.newSlides.some(slide => slide.Id === newSlide.Id);

        if (!isSlideExistsInQueue && !isSlideExistsInNewSlides) {
          this.$set(this.slidesQueue, this.slidesQueue.length, newSlide);
        }
      });
    }

    this.processPendingSlides();
  }

  // Обновление локальных слайдов, добавляя к ним новые
  updateLocalSlides() {
    this.localSlides = [...this.newSlides, ...this.slides];
  }

  // обработка слайдов из очереди и добавление их в newSlides
  processPendingSlides() {
    while (this.slidesQueue.length) {

      const newSlide = this.slidesQueue.shift();

      // Проверка на уникальность по Id
      const isSlideExists = this.newSlides.some(slide => slide.Id === newSlide.Id);

      if (!isSlideExists) {
        this.newSlides.push(newSlide);
      }
    }

    this.updateLocalSlides();
  }

  // добавляем новые слайды к локальным слайдам
  updateLocalSlidesWithNewData(...newSlides: any[]) {
    this.localSlides = [...newSlides, ...this.localSlides];
  }

  removeSlide(slide) {
    const index = this.localSlides.findIndex(s => s.Id === slide.Id);
    if (index !== -1) {
        this.localSlides.splice(index, 1);
    }
  }

  created() {
    this.newSlides = [];
    window.addEventListener("resize", this.updateWidth);
  }

  mounted() {
    if (!this.localSlides.length) {
      this.localSlides = [...this.slides];
    }
    this.updateWidth();
  }
}
